import {
  CircleMode,
  DirectMode,
  DragCircleMode,
  SimpleSelectMode
} from "mapbox-gl-draw-circle";

import { ViewportCircleMode } from "./ViewportCircleMode";
import { activeStates } from "@mapbox/mapbox-gl-draw/src/constants";
import circle from "@turf/circle";

// Show Preview Circle
CircleMode.onMouseMove = function (state, e) {
  const center = [e.lngLat.lng, e.lngLat.lat];
  const circleFeature = circle(center, state.initialRadiusInKm);
  state.polygon.incomingCoords(circleFeature.geometry.coordinates);
};

// Fix: Input data given to 'mapbox-gl-draw-cold' is not a valid GeoJSON object
// Reference: https://github.com/iamanvesh/mapbox-gl-draw-circle/pull/12
DragCircleMode.toDisplayFeatures = function (state, geojson, display) {
  const isActivePolygon = geojson.properties.id === state.polygon.id;
  geojson.properties.active = isActivePolygon
    ? activeStates.ACTIVE
    : activeStates.INACTIVE;
  if (state.polygon.properties.center.length > 0) return display(geojson);
};

export const circleMode = {
  draw_circle: CircleMode,
  draw_viewport_circle: ViewportCircleMode,
  drag_circle: DragCircleMode,
  direct_select: DirectMode,
  simple_select: SimpleSelectMode
};
